
import BasicState from "@libs/basic-view"
import FestivalAdminListForm from "./festival-admin-list/FestivalAdminListForm"

export default class FestivalAdminListView extends BasicState {
    props: any
    addRender = () => {
        return <FestivalAdminListForm {...this.props} /> 
    }
}